import { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import {
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	Text,
	Box,
	useColorModeValue,
	IconButton,
} from '@chakra-ui/react';
import { TimeIcon } from '@chakra-ui/icons';
import ClockContainer from './ClockContainer';
import { currentTZ } from 'utils/helpers';
// import { useFetchItemsQuery } from 'api/apiSlice';

const DigitalClockDropdown = () => {
	const tz = localStorage.getItem('timezone_cache') || currentTZ;

	const [currentTime, setCurrentTime] = useState(moment.tz(tz));
	// const [timezone, setTimezone] = useState(currentTimezone);

	// Format using moment-timezone
	const formattedDate = currentTime.format('DD MMMM YYYY');
	const formattedTime = currentTime.format('hh:mm:ss A');
	const timezoneAbbr = currentTime.tz(tz).format('z');
	const dayName = currentTime.format('dddd'); // Returns full day name (e.g., "Monday")

	// The old light value here was gold.100 (#FFE3CC) — pale peach text on the
	// white dropdown card, 1.23:1: the entire clock panel was invisible in
	// light mode. Semantic tokens flip correctly with the mode.
	const textColor = 'text.primary';
	const accentColor = 'text.accent';

	return (
		<Menu closeOnSelect={false}>
			{/* <MenuButton
				as={Box}
				bg='brand.500'
				boxSize={10}
				borderRadius='full'
				p='2.8'
				cursor='pointer'
				aria-label='Current time dropdown'
				_hover={{ opacity: 0.9 }}
				display='flex'
				alignItems='center'
				justifyContent='center'
			>
				<TimeIcon boxSize={5} color='white' />
			</MenuButton> */}
			<MenuButton
				as={IconButton}
				icon={<TimeIcon />}
				variant='solid'
				rounded='full'
				colorScheme='brand'
				aria-label='Notifications'
			/>
			<MenuList
				minWidth='260px'
				p={4}
				// Token names never resolve inside a CSS shorthand string — the old
				// `border='1px solid gold.400'` was dropped by the browser and the
				// panel rendered borderless. Split props resolve tokens properly.
				border='1px solid'
				borderColor='border.gold'
				borderRadius='20px'
				bg='bg.surface'
				boxShadow='card'
			>
				<MenuItem
					as={Box}
					_hover={{ bg: 'transparent' }}
					_focus={{ bg: 'transparent' }}
				>
					<ClockContainer
						formattedDate={formattedDate}
						formattedTime={formattedTime}
						textColor={textColor}
						accentColor={accentColor}
						timezone={tz}
						timezoneAbbr={timezoneAbbr}
						// setTimezone={setTimezone}
						dayName={dayName}
					/>
				</MenuItem>
			</MenuList>
		</Menu>
	);
};

export default DigitalClockDropdown;
